import React from "react";
import { TableHeader } from "@/components/table";
import { ChevronUpDownIcon } from "@heroicons/react/24/outline";
import { ArrowUpIcon, ArrowDownIcon } from "@heroicons/react/16/solid";

interface SortableTableHeaderProps<T extends string> {
  children: React.ReactNode;
  sortKey: T;
  currentSortField: T | null;
  sortOrder: "asc" | "desc";
  onSort: (field: T) => void;
  className?: string;
}

const SortableTableHeader = <T extends string>({
  children,
  sortKey,
  currentSortField,
  sortOrder,
  onSort,
  className = "",
}: SortableTableHeaderProps<T>) => {
  const isActive = currentSortField === sortKey;

  const renderSortIcon = () => {
    if (isActive) {
      return sortOrder === "asc" ? (
        <ArrowUpIcon className="h-3 w-3 text-gray-500" />
      ) : (
        <ArrowDownIcon className="h-3 w-3 text-gray-500" />
      );
    } else {
      return <ChevronUpDownIcon className="h-4 w-4 text-gray-400" />;
    }
  };

  return (
    <TableHeader
      className={`cursor-pointer select-none hover:bg-gray-50 ${className}`}
      onClick={() => onSort(sortKey)}
    >
      <div className="flex items-center gap-1">
        {children}
        {renderSortIcon()}
      </div>
    </TableHeader>
  );
};

export default SortableTableHeader;
